import classNames from 'classnames';
import { ArrowIcon } from '../../icons';
import { ActionBtnInterface } from './action-btn.interface';
import styles from './action-btn.module.css';

const ActionBtn: React.FunctionComponent<ActionBtnInterface> = ({
  text,
  iconRotate = 0,
  className,
  ...props
}) => {
  return (
    <a
      {...props}
      className={classNames(
        styles.component,
        className,
      )}
    >
      <ArrowIcon
        className={classNames(
          styles.icon,
        )}
        style={{
          transform: `rotate(${iconRotate}deg)`,
        }}
      />

      <span className={classNames(styles.text)}>{text}</span>
    </a>
  );
};

export default ActionBtn;
